/**
 * checkbox.js
 */

import React from 'react';
import { 
  FormControlLabel,
  Checkbox as MuiCheckbox,
} from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';


export default function Checkbox(props) {
  const {
    formContext: formContextProp,
    name,
    rules,
    defaultValue,
    focusHandlers,
    ...rest
  } = props;

  const formContextDefault = useFormContext();
  const formContext = formContextProp || formContextDefault;


  return (
    <Controller
      control={formContext.control}
      name={name}
      rules={rules}
      defaultValue={defaultValue}
      render={({ field: { ref, ...inputProps } }) => (
        <FormControlLabel
          label={rest.label}
          onFocus={e => {
            if (focusHandlers) {
              focusHandlers.onFocus(e);
            }
          }}
          onBlur={e => {
            inputProps.onBlur(e);
            if (focusHandlers) {
              focusHandlers.onBlur(e);
            }
          }}
          control={
            <MuiCheckbox
              color="primary"
              inputRef={ref}
              {...inputProps}
              checked={inputProps.value}
              onChange={e => inputProps.onChange(e.target.checked)}
              data-testid={`${name}-checkbox`}
              {...rest}
            />
          }
        />
      )}
    />
  );
}